import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { AverageageofsugarcaneListService } from '../../service/averageageofsugarcane-list/averageageofsugarcane-list.service';

@Component({
	selector: 'app-averageageofsugarcane-list',
	templateUrl: './averageageofsugarcane-list.component.html',
	providers: [
		AverageageofsugarcaneListService,
		HttpModule
	]
})
export class AverageageofsugarcaneListComponent implements OnInit {

	private token;
	public averages: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	average: FormGroup;

	constructor(fb: FormBuilder, private averageageofsugarcaneListService: AverageageofsugarcaneListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.average = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.searchAverage(this.average.value, 0, false);
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchAverage(this.average.value, this.currentPage, false);
	}	

	searchAverage(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.averageageofsugarcaneListService.searchAverage(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.averages = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchAverage(this.average.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/averageageofsugarcane/component/averageageofsugarcane-list/averageageofsugarcane-list.component.ts